require("./bootstrap");

// import 'jquery-ui/ui/widgets/datepicker';
import "jquery-ui/ui/widgets/sortable";

import PNotify from "pnotify/dist/es/PNotify";
import PNotifyButtons from "pnotify/dist/es/PNotifyButtons";
import PNotifyAnimate from "pnotify/dist/es/PNotifyAnimate";

var bootstrapSlider = require("bootstrap-slider");
// import "jquery-ui/ui/widgets/slider";
// import 'jquery-ui/ui/widgets/tooltip';

window.Vue = require("vue").default;
require("./haggadot/vue");

var Lazy = require("jquery-lazy");
var jqueryLazyload = require("jquery-lazyload");
// var bootstrapMultiselect = require("bootstrap-multiselect");
require("./haggadot/custom");
require("./haggadot/edit-book");
require("./haggadot/view-book");

window.swal = require("sweetalert2");
window.PNotify = PNotify;
window.PNotifyButtons = PNotifyButtons;
var chosen = require("chosen-js");
var jqueryColumnizer = require("jquery-columnizer");
var owlCarousel = require("owl.carousel");
window.flatpickr = require("flatpickr");
var bootstrapColorpicker = require("bootstrap-colorpicker");

$(function ($) {
  $("img.lazy").Lazy();
});

$("img.lazy").lazyload();

// var vanillaLazyload = require("vanilla-lazyload");

// let images = document.querySelectorAll(".lazyload");
// var myLazyLoad = new vanillaLazyload({
//     elements_selector: ".lazyload"
// });

// require("./haggadot/scrapbook-half");
// require("./haggadot/vertical-scrapbook");

// if (typeof variable !== 'undefined' && page == 'view_book_page') {

// }

// // $("#datepicker").datepicker();
